'use strict';

var profileCard = (function(window, undefined) {

    var SELECTORS = {
        pattern: '.pattern',
        card: '.profilecard',
        cardImage: '.profile_card_image',
        cardClose: '.profile_card_btn-close',
    };

    var CLASSES = {
        patternHidden: 'pattern--hidden',
        polygon: 'polygon',
        polygonHidden: 'polygon--hidden'
    };

    var layout = [];

    function init() {
        _bindCards();
    };

    function _bindCards() {
        var elements = cash(SELECTORS.card);
        cash.each(elements, function(card, i) {
            var instance = new ProfileCard(i, card);
            layout[i] = { card: instance };

            var cardImage = cash(card).find(SELECTORS.cardImage);
            var cardClose = cash(card).find(SELECTORS.cardClose);

            _hideCards(i);
            // events are commented in original code
            // cash(cardImage).on('click', _playSequence.bind(this, true, i));
            // cash(cardClose).on('click', _playSequence.bind(this, false, i));
        });
    };

    function _playSequence(isOpenClick, id, e) {
        var pos = e ? { x: e.x, y: e.y } : { x: 0, y: 0 };
        var card = layout[id].card;

        if (card.isOpen && isOpenClick) return;

        if (!card.isOpen) {
            // Open card
            _showHideOtherCards(id, false);
            card.openCard(_onCardMove, pos);
            setTimeout(addMyClass, 2500);
        } else {
            // Close card
            card.closeCard();
            _showHideOtherCards(id, true);
        }
    };

    function addMyClass() {
        var that = document.querySelector('.new_ee_profile');
        if (that) {
            that.className += " animated";
        }
    }

    function _showHideOtherCards(id, closing) {
        for (var i in layout) {
            var card = layout[i].card;
            if (card.id !== id) {
                if (closing) {
                    card.showCard();
                } else {
                    card.hideCard();
                }
            }
        }
    }

    function _onCardMove(track) {
        // Keep original logic, currently empty
    //    var radius = track.width / 2;
     //   var center = { x: track.x, y: track.y };
    //    var zoom = (typeof currentZoomLevel !== 'undefined') ? //currentZoomLevel : 1;
    }

    function customPlaySequence(x, y, id) {
        var pos = { x: x, y: y };
        var card = layout[id].card;
        card.showCard();
        card.openCard(_onCardMove, pos);
    };

    function customClose(id) {
        var card = layout[id].card;
        card.hideCard();
        card.closeCard();
        _showHideOtherCards(id, true);
    }

    function _hideCards(id) {
        var card = layout[id].card;
        card.hideCard();
        _showHideOtherCards(id, false);
    }

    return {
        init: init,
        customPlaySequence: customPlaySequence,
        customClose: customClose
    };

})(window);

function eePopUp(e, id) {
    var x = 0, y = 0;

    if (e && !jQuery(".profilecard").hasClass("animated")) {
        x = e.target.offsetLeft;
        y = e.target.offsetTop - 100;
    }

    profileCardWrapper.openCard(id, { x: x, y: y });
}

// Close a card
function eePopUpClose(id) {
     console.log("eePopUpClose called with id:", id);
    profileCardWrapper.closeCard(id);
}








